// src/pages/DirectExpenseBalance/components/exportDirectExpenseBalanceCsv.js

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.list          - from Redux state.directExpenseBalance.list
 * @param {number}  params.balanceTotal  - from Redux state.directExpenseBalance.balanceTotal
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportDirectExpenseBalanceCsv = ({
  list,
  balanceTotal,
  title    = "Direct Expense Balance Report",
  filename = "direct_expense_balance",
}) => {
  const headers = [
    "No.", "Account Name", "Opening Balance",
    "Debit Amount", "Credit Amount", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.acc_name        || "",
    fmt(row.opening_balance),
    fmt(row.debit_amount),
    fmt(row.credit_amount),
    fmt(row.balance),
  ].map(escape));

  const openingTotal = list.reduce((s, r) => s + Number(r.opening_balance || 0), 0);
  const debitTotal   = list.reduce((s, r) => s + Number(r.debit_amount    || 0), 0);
  const creditTotal  = list.reduce((s, r) => s + Number(r.credit_amount   || 0), 0);

  const totalRow = [
    "Grand Total:", "",
    fmt(openingTotal),
    fmt(debitTotal),
    fmt(creditTotal),
    fmt(balanceTotal),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};